import { put, takeEvery, call } from 'redux-saga/effects';
import * as actions from '../../actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import companyServices from '../../../services/companyServices';

export default function* updateCompanyServiceSaga() {
  yield takeEvery(actionTypes.COMPANY_SERVICE.UPDATE_COMPANY_SERVICE_REQUEST, updateCompanyServices);
}

export function* updateCompanyServices(action) {
  try {
    const response = yield call(companyServices.update, action.payload);
    const { success, data } = response;
    if (success) {
      yield put(actions.updateCompanyServiceSuccess(data));
      if (action.payload.serviceId === 3) {
        yield put(actions.setSettingPaymentStatus({ id: action.payload.id, isPaymentOn: action.payload.isVerified }));
      }
    } else {
      yield put(actions.updateCompanyServiceFail(response));
    }
  } catch (error) {
    console.log(error);
    yield put(actions.updateCompanyServiceFail(error));
  }
}
